const chatData = [

    {
        id: 2,
        image: require('@/assets/images/users/avatar-3.jpg'),
        name: 'Cliente Testes 0099',
        message: 'TK0088',
        time: '1 minuto',
        color: 'success'
    },
    {
        id: 3,
        name: 'Cliente Testes 0088',
        message: 'TK0087',
        time: '24 min',
        color: 'success'
    },
    {
        id: 4,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Cliente Testes 0077',
        message: 'TK0086',
        time: '1 hr',
        color: 'warning'
    },
    {
        id: 5,
        name: 'Cliente Testes 0074',
        message: 'TK0085',
        time: '3 hrs',
        color: 'secondary'
    },
    {
        id: 6,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Cliente Testes 0071',
        message: 'TK0084',
        time: '5 hrs',
        color: 'success'
    },
    {
        id: 7,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Cliente Testes 0066',
        message: 'TK0083',
        time: '5 hrs',
        color: 'success'
    },
];

const chatMessagesData = [
    {
        name: 'Cliente Testes 0099',
        message: 'Bom dia!',
        time: '07:30'
    },
    {
        align: 'right',
        name: 'BIA',
        message: 'Olá, bom dia! Sou a Bia, inteligência artificial da _ParEmpresa08_, como posso ajudar?',
        time: '07:30'
    },
    {
        name: 'Cliente Testes 0099',
        message: 'Gostaria de comprar máscara descartável, pode me ajudar?',
        time: '07:32'
    },
    {
        align: 'right',
        name: 'BIA',
        message: 'Claro, veja no link https://pote-pink.vercel.app/loja?categ=preenchedores as melhores ofertas, vi que comprou 5 unidades deste produto a 32 dias, digitando repetir pedido posso refazer seu pedido.',
        time: '07:32'
    },
    {
        name: 'Cliente Testes 0099',
        message: 'repetir pedido',
        time: '07:33'
    },
    {
        align: 'right',
        name: 'BIA',
        message: 'Obrigada! Seu pedido foi confirmado com sucesso, mais detalhes em: https://pote-pink.vercel.app/pages/account',
        time: '07:33'
    },
];


const lineChart = {
    type: "line",
    data: {
        labels: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
        ],
        datasets: [{
            label: "Comercial",
            fill: true,
            lineTension: 0.5,
            backgroundColor: "rgba(85, 110, 230, 0.2)",
            borderColor: "#556ee6",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "#556ee6",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "#556ee6",
            pointHoverBorderColor: "#fff",
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [65, 59, 80, 81, 56, 55, 40, 55, 30, 80],
        },
            {
                label: "Outros",
                fill: true,
                lineTension: 0.5,
                backgroundColor: "rgba(235, 239, 242, 0.2)",
                borderColor: "#ebeff2",
                borderCapStyle: "butt",
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: "miter",
                pointBorderColor: "#ebeff2",
                pointBackgroundColor: "#fff",
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: "#ebeff2",
                pointHoverBorderColor: "#eef0f2",
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: [80, 23, 56, 65, 23, 35, 85, 25, 92, 36],
            },
        ],
    },
    options: {
        defaultFontColor: "#8791af",
        responsive: true,
        maintainAspectRatio: true,

        xAxes: [{
            gridLines: {
                color: "rgba(166, 176, 207, 0.1)",
            },
        },],
        yAxes: [{
            ticks: {
                max: 100,
                min: 20,
                stepSize: 10,
            },
            gridLines: {
                color: "rgba(166, 176, 207, 0.1)",
            },
        },],
    },

};


export { chatData, chatMessagesData, lineChart };